import React from 'react'

import { useMobileShellMedia } from '@/hooks/useMobileShellMedia'

import DesktopHomePage from './DesktopHomePage'
import MobileHomePage from './mobile/MobileHomePage'

export default function Home() {
  const isMobileShell = useMobileShellMedia()
  return isMobileShell ? <MobileHomePage /> : <DesktopHomePage />
}
